export const color = {
  escuro: "#010101",
  barra: "#0f0f0f",
  fundo: "#F5F5F5",
  branco: "#ffffff",
  verde: "#888f50",
};
